import script from "./HistoryEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryEditor.vue?vue&type=script&setup=true&lang=js"

import "./HistoryEditor.vue?vue&type=style&index=0&id=d356ab4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d356ab4c"]])

export default __exports__